import { useEffect, useState } from "react";

function getReducedMotion(): boolean {
  try {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return false;
    }
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    return Boolean(mq?.matches);
  } catch {
    return false;
  }
}

/** OS/브라우저의 “움직임 줄이기” 설정과 동기화 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(getReducedMotion);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mq) return;

    const handler = () => setReduced(mq.matches);

    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
    if (typeof mq.addListener === "function") {
      mq.addListener(handler);
      return () => {
        if (typeof mq.removeListener === "function") mq.removeListener(handler);
      };
    }
    return undefined;
  }, []);

  return reduced;
}
